export default __webpack_public_path__ + "static/media/github.740db6be.svg";